var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":_vm.title}},[_c('ve-ring',_vm._b({attrs:{"height":_vm.height}},'ve-ring',_vm.ringOption,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }